/**
 * Keep in sync with server `src/utils/symbol.ts` extractBaseSymbol — used to match
 * DB trade.symbol with BingX/CCXT position.symbol.
 */
export function extractBaseSymbol(symbol: string): string {
  const s = symbol.trim();
  if (/\/USDT:USDT$/i.test(s)) {
    return s.replace(/\/USDT:USDT$/i, '');
  }
  if (/-USDT-SWAP$/i.test(s)) {
    return s.replace(/-USDT-SWAP$/i, '');
  }
  return s
    .replace(/-USDT$/i, '')
    .replace(/USDT$/i, '');
}

export function positionMatchKey(symbol: string, side: string): string {
  return `${extractBaseSymbol(symbol).toUpperCase()}|${String(side).toUpperCase()}`;
}
